// src/pages/letters/New.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import LetterForm, { emptyForm, buildPayload, validateForm, discardUnsavedAttachments } from './LetterForm';


const New = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const isDirtyRef = useRef(false);
const [uploading, setUploading] = useState(false);

  const show = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);
  };


  const cancel = async () => {
  await discardUnsavedAttachments(form.attachments, []);
  isDirtyRef.current = false;
  navigate('/dashboard/letters');
};
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  useEffect(() => {
    const handler = (e) => {
      if (!isDirtyRef.current) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, []);

  const markDirty = () => {
    isDirtyRef.current = true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
if (uploading) {
  show('تا پایان آپلود پیوست صبر کنید', 'danger');
  return;
}

    const err = validateForm(form);
    if (err) {
      show(err, 'danger');
      return;
    }

    setSaving(true);
    try {
      await api.post('/letters', buildPayload(form));
      isDirtyRef.current = false;
      show('نامه با موفقیت ثبت شد', 'success');
      setTimeout(() => navigate('/dashboard/letters'), 800);
    } catch (error) {
      console.error('خطا در ثبت نامه:', error);
      show(error.response?.data?.error || 'خطا در ثبت نامه', 'danger');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {message && (
        <div className={messageType === 'danger' ? 'toast-danger' : 'toast-success'}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <LetterForm form={form} setForm={setForm} serial="" onDirty={markDirty} onMessage={show}  onUploadingChange={setUploading}/>

        <div className="flexend">
         <button type="button" className="btn secondary" onClick={cancel} disabled={uploading || saving}>
  <i className="fa-solid fa-xmark" /> انصراف
</button>
        <button className="btn" type="submit" disabled={saving || uploading}>
  {!saving && !uploading && <i className="fa-solid fa-floppy-disk" />}
  {uploading ? 'در حال آپلود پیوست...' : saving ? 'در حال ذخیره...' : 'ثبت نامه'}
</button>
        </div>
      </form>
    </>
  );
};

export default New;